import React from 'react';
import { withRouter } from "react-router-dom";
import {
    Grid,
    Segment,
    Image,
    Header,
    SubHeader
} from 'semantic-ui-react';

import FormsUpdateProfile from '../../forms/profile/update_profile';
import FormsUpdateNameNRIC from '../../forms/profile/update_name_nric';
import FormsUpdateEmail from '../../forms/profile/update_email';
import FormsUpdateContactNumber from '../../forms/profile/update_contact_number';
import FormsUpdateProfilePhoto from '../../forms/profile/update_profile_photo';
import FormsUpdatePassword from '../../forms/profile/update_password';
import FormsUpdateBankAccount from '../../forms/profile/update_bank_account';

class ProfileBioUpdate extends React.Component {

    constructor(props) {
        super(props)
        this.segmentUpdatePassword = React.createRef()   // Create a ref object 
    }

    componentDidMount(){
        if(this.props.history && this.props.history.location.hash==="#SegmentUpdatePassword" && this.segmentUpdatePassword.current){
            const offsetTop = this.segmentUpdatePassword.current.getBoundingClientRect().top - 80;
            window.scrollTo(0, offsetTop);
        }
    }

    render(){
        const userMemberType = this.props.user.companies.filter(company => company.memberType.toUpperCase() == 'E').length

        return (
            <Grid centered>
                <Grid.Row>
                    {
                        /*
                        <Grid.Column centered width={3}>
                            <Grid.Row>
                                <Image src={props.profilePhoto} fluid circular size='medium'/>
                            </Grid.Row>
                        </Grid.Column>
                        */
                    }
                    <Grid.Column width={16}>
                        <Grid.Row>
                            {/* Change My Profile Photo */}
                            <Segment attached>
                                <Grid.Column>
                                    <Header as='h4' attached='top' block>
                                        Change My Profile Photo
                                    </Header>
                                    <Segment attached>
                                        <FormsUpdateProfilePhoto
                                            submitNewProfilePhoto={this.props.submitNewProfilePhoto}
                                            getUserProfilePhoto={this.props.getUserProfilePhoto}
                                            user={this.props.user}
                                        />
                                    </Segment>
                                </Grid.Column>
                            </Segment>
    
                            {/* Change My Details*/}
                            <Segment attached>
                                <Grid.Column>
                                    <Header as='h4' attached='top' block>
                                        Change My Details
                                    </Header>
                                    <Segment attached>
                                        <Header.Subheader>
                                            <br/>
                                            Note: Your changes will be submitted to INCOME for approval.
                                            <br/>
                                            <br/>
                                        </Header.Subheader>
                                        <FormsUpdateNameNRIC
                                            user={this.props.user}
                                            updateUserProfileChangeNameAndNRIC={this.props.updateUserProfileChangeNameAndNRIC}
                                        />
                                    </Segment>
                                </Grid.Column>
                            </Segment>
    
                            {/* Change My Email */}
                            { (this.props.user.memberType.toUpperCase() == 'E' && this.props.configBenefit.featuresConfig.allowEmployeeChangeEmail) || (this.props.user.memberType.toUpperCase() == 'D' && this.props.configBenefit.featuresConfig.allowDependantChangeEmail) ?
                            <Segment attached>
                                <Grid.Column>
                                    <Header as='h4' attached='top' block>
                                        Change My Email
                                    </Header>
                                    <Segment attached>
                                        <FormsUpdateEmail
                                            user={this.props.user}
                                            verifyPasswordAction={this.props.verifyPasswordAction}
                                            updateUserProfileInformation={this.props.updateUserProfileInformation}
                                            updateUserProfileGenerateChangeEmailOTP={this.props.updateUserProfileGenerateChangeEmailOTP}
                                            updateUserProfileVerifyChangeEmailOTP={this.props.updateUserProfileVerifyChangeEmailOTP}
                                        />
                                    </Segment>
                                </Grid.Column>
                            </Segment> : null }
    
                            {/* Change Contact My Contact Number */}
                            <Segment attached>
                                <Grid.Column>
                                    <Header as='h4' attached='top' block>
                                        Change My Contact Number
                                    </Header>
                                    <Segment attached>
                                        <FormsUpdateContactNumber
                                            user={this.props.user}
                                            verifyPasswordAction={this.props.verifyPasswordAction}
                                            countryCodeOptions={this.props.countryCodeOptions}
                                            updateUserProfileInformation={this.props.updateUserProfileInformation}
                                        />
                                    </Segment>
                                </Grid.Column>
                            </Segment>
    
                            {/* Change My Password */}
                            <Segment attached>
                                <Grid.Column>
                                    <Header as='h4' attached='top' block>
                                        <div ref={this.segmentUpdatePassword}>Change My Password</div>
                                    </Header>
                                    <Segment attached>
                                        <Header.Subheader>
                                            <br/>
                                            To protect your account, please note your password must be at least 8 characters long;
                                            <br/>
                                            - include number, uppercase and lowercase letter
                                            <br/>
                                            <br/>
                                        </Header.Subheader>
                                        <FormsUpdatePassword
                                            user={this.props.user}
                                            updateUserProfileChangePassword={this.props.updateUserProfileChangePassword}
                                        />
                                    </Segment>
                                </Grid.Column>
                            </Segment>
    
                            {/* Add Bank Account Details - only show when bank account is empty */}
                            {
                                !this.props.user.bankDetail.accountNo && userMemberType > 0
                                &&
                                <Segment attached>
                                    <Grid.Column>
                                        <Header as='h4' attached='top' block>
                                            Bank Account Details
                                        </Header>
                                        <Segment attached>
                                            <FormsUpdateBankAccount
                                                user={this.props.user}
                                                claimOptions={this.props.claimOptions}
                                                updateUserProfileInformation={this.props.updateUserProfileInformation}
                                            />
                                        </Segment>
                                    </Grid.Column>
                                </Segment>
                            }
                        </Grid.Row>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }

}

export default withRouter(ProfileBioUpdate);
